require('./brokerExAntSection.scss')

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText } = require('core/i18n').i18n;
const BrokerExAntSubSection = require('components/commons/brokerExAntSubSection/brokerExAntSubSection');
const BrokerExAntItem = require('components/commons/brokerExAntItem/brokerExAntItem');

class BrokerExAntSection extends React.Component {
    buildKey(key) {
        const { context } = this.props;
        return `${context}-${key}`
    }

    buildDetails() {
        const { section, context, eventCategory, complexTooltip } = this.props;
        if (!!section.get('details')) {
            return section
                .get("details")
                .map((detail, index) => (
                    <BrokerExAntSubSection
                        section={detail}
                        context={context}
                        key={index}
                        eventCategory={eventCategory}
                        sectionTitle={section.get("descriptionKey")}
                        complexTooltip={complexTooltip}
                    />
                ));
        }
    }

    render() {
        const { section, context, eventCategory, complexTooltip } = this.props;
        if (!!section.get('type') && section.get('type') === 'PROFITABILITY') {
            return null
        }
        const separator = !!section.get('details') && (<div className="broker-ex-ant-cost__section-total-separator" />);
        if (!!section.get('hidden')) {
            return null;
        }
        return (
            <div className="broker-ex-ant-cost__section">
                <FormattedText className="broker-ex-ant-cost__section-title" value={this.buildKey(section.get('descriptionKey'))} />
                <div className="broker-ex-ant-cost__section-details">
                    {this.buildDetails()}
                </div>
                <div className="broker-ex-ant-cost__section-total">
                    {separator}
                    <BrokerExAntItem
                        data={section.get('total')}
                        context={context}
                        sectionTitle={this.buildKey(section.get('descriptionKey'))}
                        eventCategory={eventCategory}
                        complexTooltip={complexTooltip}
                    />
                </div>
            </div>
        );
    }
}

BrokerExAntSection.defaultProps = {
    complexTooltip: false,
}

BrokerExAntSection.propTypes = {
    section: PropTypes.object,
    context: PropTypes.string,
    eventCategory: PropTypes.string,
    complexTooltip: PropTypes.bool,
}


module.exports = BrokerExAntSection;
